import styled from 'styled-components';

const EmployesStyle = styled.div`
   padding-top: 200px;
    position: relative;
    overflow-y: hidden;
    @media (max-width: 767px){
        padding-top: 130px;
    } 
    .main_employes_section{ 
        display: flex;
        flex-direction: column;
        align-items: center;
        .first_content_section{
            padding-top: 30px;
        }
        .title_sections { 
            text-align: center;
            position: relative;
            z-index: 1; 
            h2 {
            background: linear-gradient(40deg, #25aae1 0%, #17aabc 24%, #24a67b 100%); 
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            }
            h3{
                font-size: 38px;
                line-height: 38px;
                color: #000000;
                font-family: var(--common-font);
                text-align: center;
                margin-bottom: 25px;
                @media (max-width: 1280px){ 
                    font-size: 36px;
                    line-height: normal;
                }
                @media (max-width: 1199.98px){ 
                    font-size: 30px; 
                }
                @media (max-width: 991px){ 
                    font-size: 26px; 
                }
                @media (max-width: 767px){
                    font-size: 24px;
                    margin-bottom: 0;
                }
            }
        } 
        .text_container {
            width: 100%;  
            position: relative;
            z-index: 1;  
            .container{
                    .d-flex.row {
                        gap: 100px;
                        background: linear-gradient(90deg, #e0e4e6db 0%, #c0cbd1cf 100%); 
                        & ::after,& ::before{
                            display: none;
                        }
                        @media (max-width: 1365px){
                            gap: 50px;
                        }
                        @media (max-width: 1199.98px){
                            gap: 0px;
                        }
                        @media (max-width: 1024px){
                        flex-wrap: wrap;
                        .col-md-6{
                                max-width: 100%;
                                flex: 100%;
                            }
                        }
                    }
                }
                p {
                font-size: 24px;
                color: #000000;
                font-family: var(--common-font);  
                @media (max-width: 767px){
                    font-size: 22px;
                    line-height: normal;
                    text-align: center;
                }
            }
            .first_content_section {
                .image_text_one{
                    gap: 15px;
                    margin: 30px 0;
                    &>div{
                        flex: 1;
                    }
                    .image {
                    max-width: 240px;
                    }
                }
                .image_text_one, .image_text_two {
                    display: flex; 
                    .image{
                        img {
                            max-width: 280px;
                        }
                    }
                }
            }
        }
        .message_tip {
            position: relative;
            margin-bottom: 40px;
            @media (max-width: 1024px){ 
                            max-width: 610px;
                            margin: 40px auto 0;
                            display: block;
                        }
                        @media (max-width: 991px){
                            max-width: 600px; 
                        }
                        @media (max-width: 767px){
                            max-width: 350px;
                        }
            .image {
                    position: relative;
                    margin-bottom: 100px;
                    @media (max-width: 767px){
                        margin-bottom: 30px;
                    }
                    &:before {
                        content: "";
                        position: absolute;
                        top: calc(100% - 7px);
                        width: 0;
                        height: 0;
                        border-top: 52px solid #1baac7;
                        border-right: 52px solid transparent;
                        z-index: 99;
                        left: 14vw;
                        @media (max-width: 1024px){
                            left: 21vw;
                        }
                        }
                    img {
                        width: 100%; 
                    } 
                }
            .content-quote {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                max-width: 520px;
                text-align: center;  
                @media (max-width: 767px){
                    padding: 10px;
                }
                P{
                    color: #fff;
                    @media (max-width: 1280px){
                    font-size: 24px; 
                   }
                    @media (max-width: 1199px){
                    font-size: 22px;
                    line-height: normal;
                    text-align: center;
                   }
                    @media (max-width: 767px){
                        font-size: 14px; 
                    }
                }
                a{
                    font-size: 24px;
                    color: #fff;
                    font-family: var(--common-font);
                    @media (max-width: 1199px){
                        font-size: 24px;
                        line-height: normal; 
                    }
                    @media (max-width: 767px){
                        font-size: 20px;
                        line-height: normal; 
                    }
                    &.elementor-testimonial-name {
                        /* font-family: "pt sans", Sans-serif !important; */
                        text-transform: capitalize;
                        text-decoration: underline;
                        font-weight: 400 !important;
                    }  
                } 
            }
        } 
        .button_sections {
            margin: 50px 0 80px;
            display: flex;
            gap: 20px;
            justify-content: center;
            @media (max-width: 1199px){
                margin: 50px 0 30px;
                }
            button {
                background-color: var(--green);
                border-radius: 30px;
                font-size: 20px;
                color: #ffffff;
                font-weight: bold;
                font-family: var(--exo);
                text-align: center;
                border: none;
                @media (max-width: 1024px){
                    font-size: 28px;
                    }
                    @media (max-width: 767px){
                    font-size: 20px;
                    line-height: normal;
                    }
            }
        } 
    } 

    .content-area {
                ul {
                padding-left: 30px;
                @media (max-width: 1024px){
                margin: 0 0 50px;
                }
                @media (max-width: 767px){
                margin: 0 0 30px;
                }
                    li {
                    font-size: 26px;
                    color: #000000;
                    font-family: var(--common-font); 
                    @media (max-width: 767px){
                    font-size: 22px;
                    margin-bottom: 5px;
                    }
                }
            }
    }
    a{
        color: #fff;
    font-size: 20px;
    font-family: var(--exo);
    }
`;

export default EmployesStyle;
